import './Address.css';

export const Address = ({details}) => {
    return (
        <span className='developmentAddress'>{details.development_address}</span>
    )
}